import { btoa } from '@/helpers/base64-helper';

/** Generate a random string with the specified length. */
export function generateRandomString(length = 22, radix?: number): string {
	const BASE64URICHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('');
	radix = radix || BASE64URICHARS.length;
	const newId = [];
	for (let i = 0; i < length; i++) {
		newId[i] = BASE64URICHARS[0 | (Math.random() * radix)];
	}
	return newId.join('');
}

/**
 * Generates a valid 22 character JustWatch Id
 * @param tag tag on ID to help filter by platform
 */
export function generateJwId(tag = 'C') {
	// `crypto.randomUUID` is still very new and might not be in all browsers
	const uuid = (crypto.randomUUID?.() ?? generateRandomString(36)).replace(/-/g, '');
	const byteArray = new Uint8Array(uuid.match(/.{1,2}/g)!.map(byte => parseInt(byte, 16)));
	const jwId = btoa(String.fromCharCode(...byteArray))
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
		.slice(0, 22);

	return jwId.substring(0, 16) + tag + jwId.substring(17);
}

export async function generateHashedEmail(email: string): Promise<string> {
	const encoder = new TextEncoder();
	const data = encoder.encode(email);

	const hashBuffer = await crypto.subtle.digest('SHA-256', data);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export function generateUUIDv4(): string {
	// `crypto.randomUUID` is not available to all broswers
	if (crypto?.randomUUID) {
		return crypto.randomUUID();
	}

	// Fallback using manual generation (RFC4122 version 4 compliant)
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}
